import { HamNavBar } from "./HamNavBar";



const menuItems = [
    {
        label: "About",
        key: "about",
        link: "#about",
    },
    {
        label: "Experience",
        key: "experience",
        link: "#experience",
    },
    {
        label: "Projects",
        key: "projects",
        link: "#projects",
    },
    // {
    //     label: "Activities",
    //     key: "activities",
    //     link: "#activities",
    // }
];

export function NavBar() {
    return (
        <nav className="h-14 w-full flex fixed items-center justify-center px-8 z-50">
            {/* <a href="#hero" className="flex-1 pl-20">Chau Nguyen</a> */}

            {/* Medium and bigger screen menu */}
            <div className="rounded-full px-4 py-2 bg-red-100 space-x-12 md:flex hidden font-dmsans font-semibold text-sm">
                {menuItems.map(item => 
                    <a href={item.link} className="hover:text-red-600">{item.label}</a>
                )}
            </div>
            {/* Small screen menu */}
            <div className="flex md:hidden">
                <HamNavBar menuItems={menuItems}/>
            </div>
        </nav>
    )
}